export const oidcSettings = {
  authority: process.env.VUE_APP_OIDC_AUTHORITY,
  clientId:  process.env.VUE_APP_OIDC_CLIENT_ID,
  redirectUri: process.env.VUE_APP_OIDC_REDIRECT_URI,
  postLogoutRedirectUri: process.env.OIDC_LOGOUT_REDIRECT_URI,
  responseType: 'code',
  scope: 'openid profile email address standard_api IdentityServerApi',
  automaticSilentRenew: true,
  silentRedirectUri: process.env.VUE_APP_OIDC_SILENT_REDIRECT_URI,
}
